export const doNothing = () => {};